import { getUrlParam } from '@/utils/index'

const IS_DEVELOPMENT_ENV = process.env.NODE_ENV === 'development'
const IS_PRODUCTION_ENV = process.env.NODE_ENV === 'production'
const DEFAULT_LANGUAGE = process.env.VUE_APP_LEGAL_REGION === 'domestic' ? 'zh-cn' : 'en-us'

export function normalizeLanguage(language) {
  const normalizedLanguage = String(language || '').trim().replace(/_/g, '-').toLowerCase()
  if (
    normalizedLanguage === 'zh-tw' || normalizedLanguage.startsWith('zh-tw-') ||
    normalizedLanguage === 'zh-hk' || normalizedLanguage.startsWith('zh-hk-') ||
    normalizedLanguage === 'zh-mo' || normalizedLanguage.startsWith('zh-mo-') ||
    normalizedLanguage === 'zh-hant' || normalizedLanguage.startsWith('zh-hant-')
  ) {
    return 'zh-tw'
  }
  if (normalizedLanguage === 'zh' || normalizedLanguage.startsWith('zh-')) {
    return 'zh-cn'
  }
  if (normalizedLanguage === 'en' || normalizedLanguage.startsWith('en-')) {
    return 'en-us'
  }
  return null
}

/**
 * 页面跳转
 * @param {string} pathname 路径跳转
 * @param {object} queryObj 路径跳转携带参数
 */
export function goToPage(pathname, queryObj = {}) {
  let pathSting = ''
  if (IS_DEVELOPMENT_ENV) {
    pathSting = `/${pathname}`
  } else if (IS_PRODUCTION_ENV) {
    const path = location.pathname
    const prefix = path.slice(0, path.lastIndexOf('/'))
    pathSting = `${prefix}/${pathname}.html`
  }
  const queryString = Object.keys(queryObj)
    .reduce((prev, key) => [prev, `${key}=${queryObj[key]}`].join('&'), '')
    .slice(1)
  location.href = `${location.origin}${pathSting}${queryString ? `?${queryString}` : ''}`
}

/**
 * 获取语言
 * @returns language
 */
export function getLanguage() {
  const urlLanguage = normalizeLanguage(getUrlParam('lang'))
  if (urlLanguage) {
    return urlLanguage
  }

  // getLocale 会优先使用有效 URL 和 Cookie；这里只处理浏览器自动语言选择。
  try {
    const isIE = (typeof document !== 'undefined' && document.documentMode) ||
      (typeof navigator !== 'undefined' && /MSIE|Trident/i.test(navigator.userAgent || ''))
    const browserLanguage = typeof navigator === 'undefined' ? null : navigator.language
    // IE 或语言读取不可用时默认简体中文；未登录初始化也走此分支。
    if (isIE || !browserLanguage) {
      return 'zh-cn'
    }
    // 可读取但暂未支持的语种仍按国内 / 国际版本兜底，保持原有逻辑。
    return normalizeLanguage(browserLanguage) || getDefaultLanguage()
  } catch (error) {
    // 旧浏览器读取语言属性异常时，静默使用简体中文。
    return 'zh-cn'
  }
}

export function getDefaultLanguage() {
  return DEFAULT_LANGUAGE
}

export function getSite() {
  let domain = process.env.VUE_APP_DOMAIN
  if(!domain){
    domain='agent_store'
  }
  return domain
}

/*
* 获取默认语言
* */
export function getDefLanguage() {
  // todo 获取浏览器默认语言
  return 'zh-cn'
}

/**
 * 获取Cookie前缀
 * @returns {string}
 */
export function getCookieKeyPrefix() {
  return 'agent_store_' + process.env.VUE_APP_ENV
}

export function elTableColumnAutoWidth(tableSelector) {
  const columnWidthList = {}
  const rows = document.querySelectorAll(
    tableSelector + ' .el-table__body .el-table__row'
  )
  const maxWidthCache = {}
  const ths = document.querySelectorAll(tableSelector + ' .el-table__header-wrapper th>div')
  for (let i = 0; i < ths.length; i++) {
    ths[i].style.textOverflow = 'unset'
    ths[i].style.whiteSpace = 'nowrap'
    ths[i].style.display = 'inline-block'
    ths[i].style.width = 'auto'
    ths[i].style.width = ths[i].scrollWidth + 'px'
    if (
      !maxWidthCache[i] ||
      maxWidthCache[i] < ths[i].scrollWidth
    ) {
      maxWidthCache[i] = ths[i].scrollWidth + 10
    }
  }
  rows.forEach((row) => {
    const tds = row.querySelectorAll('td>div')
    for (let i = 0; i < tds.length; i++) {
      tds[i].style.textOverflow = 'unset'
      tds[i].style.whiteSpace = 'nowrap'
      tds[i].style.display = 'inline-block'
      if (
        !maxWidthCache[i] ||
        maxWidthCache[i] < tds[i].scrollWidth
      ) {
        maxWidthCache[i] = tds[i].scrollWidth + 10
      }
    }
  })
  const firstTds = rows[0].querySelectorAll('td')
  let w = document.querySelector(tableSelector).clientWidth
  for (let i = 0; i < firstTds.length; i++) {
    if (maxWidthCache[i] < (w / (firstTds.length - i))) {
      maxWidthCache[i] = w / (firstTds.length - i)
    }
    columnWidthList[i] = maxWidthCache[i]
    w -= columnWidthList[i]
  }
  return columnWidthList
}

export function formatDate(dateString) {
  // 创建一个日期对象（假设输入的日期字符串是有效的ISO 8601格式）
  const date = new Date(dateString);

  // 提取年份、月份和日期（注意：月份是从0开始的，所以我们需要加1）
  const year = date.getFullYear(); // 我们不需要年份，但这里为了完整性还是提取了
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 转换为两位数字，必要时前面补0
  const day = date.getDate().toString().padStart(2, '0'); // 转换为两位数字，必要时前面补0

  // 构建所需的日期格式字符串
  const formattedDate = `${month}月${day}日`;

  return formattedDate;
}
